import { SSOProvider } from './ssoProvider';
import { LoginFormProvider } from './loginFormProvider';
import { ResourcesProvider } from './resorcesProvider';

export const loginSSOService = new SSOProvider();
export const loginFormService = new LoginFormProvider('','');
export const resourcesService = new ResourcesProvider();
